module.exports = __webpack_public_path__ + "ebebad32878e13c0cfad7e91a2fcbd54.jpg";